/**
 * Labstep
 *
 * @module core/Form/ReactForm/Text
 * @desc Editable text as a form field
 */

import { CustomTextWrapper as CustomFieldWrapper } from 'labstep-web/core/Form/ReactForm/CustomFieldWrapper';
import type React from 'react';
import { Input } from 'semantic-ui-react';
export const Text: React.FC<any> = (props) => (
  <CustomFieldWrapper
    fieldElement={Input}
    defaultValue=""
    {...props}
  />
);
